import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import BookingBanner from '../components/BookingBanner'

export default function HealingPage() {
  return (
    <>
      <MetaTags
        title="Healing - Trine Rosendal"
        description="Healing. Jeg anvender altid healing i alle mine behandlinger. Du kommer meget lettere igennem en udvikling, hvis din energi er høj."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1037-scaled.jpg"
        canonicalUrl="https://trine-rosendal.dk/healing"
      />

      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-8 sm:py-14 space-y-12 sm:space-y-16">
        {/* Header Introduction */}
        <div className="max-w-3xl space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#D6E2CB] bg-[#EEF3E8] px-3.5 py-1 text-xs font-medium text-[#4C5E43]">
            <i className="fa-solid fa-sparkles text-[11px] text-[#556B48]" aria-hidden="true" />
            <span>Energi & balance</span>
          </div>

          <h1 className="font-serif text-3.5xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D] tracking-tight">
            Healing
          </h1>

          <p className="text-base sm:text-lg text-[#4D5E46] leading-relaxed">
            Jeg anvender altid healing i alle mine behandlinger. Du kommer meget lettere igennem en udvikling, hvis din energi er høj.
          </p>
        </div>

        {/* Hero Image */}
        <div className="overflow-hidden rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] shadow-sm">
          <img
            src="/cdn-cgi/image/width=1200,quality=85,format=auto/_assets/cat-1037-scaled.jpg"
            alt="Healing hos Trine Rosendal"
            className="h-[320px] sm:h-[440px] w-full object-cover"
            onError={(e) => {
              e.currentTarget.src =
                'https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/cat-1037-scaled.jpg'
            }}
          />
        </div>

        {/* Text content from scrape */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-8 space-y-6">
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-10 shadow-xs space-y-4 text-base text-[#384632] leading-relaxed">
              <p>
                Jeg anvender altid healing i alle mine behandlinger. Du kommer meget lettere igennem en udvikling, hvis din energi er høj. Og befinder du dig i en svær periode af dit liv, mangler du højst sandsynligt energi. Jeg har evnen til at øge menneskers energi og bruger det med meget gode resultater.
              </p>
            </div>

            {/* Link to Phone Treatment Subpage - Warm Yellow Accent Card */}
            <div className="rounded-2xl border-2 border-[#ECC572] bg-gradient-to-br from-[#FFFDF7] to-[#FEF8E8] p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-xs">
              <div className="space-y-1">
                <span className="text-[11px] font-semibold uppercase tracking-wider text-[#935D08]">
                  Fjernhealing & samtale
                </span>
                <h3 className="font-serif text-xl font-medium text-[#222E1D]">
                  Behandling over telefon
                </h3>
                <p className="text-xs text-[#5C503D] max-w-md">
                  Samtale og intuitiv vejledning kombineret med fjernhealing over telefon eller FaceTime for klienter i hele landet.
                </p>
              </div>

              <Link
                to="/telefonisk-behandling"
                className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#F5D154] hover:bg-[#EABF35] px-5 py-2.5 text-xs font-semibold text-[#1E2718] transition shadow-xs"
              >
                <span>Læs om telefonisk behandling</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </Link>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="rounded-2xl border border-[#D6E2CB] bg-[#F7F9F3] p-6 space-y-4">
              <h3 className="font-serif text-lg font-medium text-[#222E1D]">
                Kombineret med hypnose
              </h3>
              <p className="text-xs text-[#5C6E52] leading-relaxed">
                Healingen understøtter hypnosens beroligende effekt på krop og sind, så du hurtigere opnår en dyb og stabiliserende tilstand.
              </p>
              <div className="pt-2 border-t border-[#D6E2CB]">
                <a
                  href="https://system.easypractice.net/book/online-booking-16"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#5C7A4F] px-4 py-2.5 text-xs font-medium text-white shadow-xs transition hover:bg-[#455C3A]"
                >
                  <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                  <span>Book tid til behandling</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <BookingBanner />
      </div>
    </>
  )
}
